import { Button, Table } from 'antd'
import React from 'react'
import { URL } from '../../Redux/common/url';

const OurTeamTable = ({ our_team_list }) => {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Image',
      dataIndex: 'image',
      key: 'image',
      render: (value, item, index) => {
        return (
          <img
            src={URL?.API_BASE_URL + item?.image}
            alt=""
            style={{ width: "100px" }}
          />
        );
      }
    },
    {
      title: 'Designation',
      dataIndex: 'designation',
      key: 'designation',
    },
    {
      title: 'Discription',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (value, item, index) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => console.log(item)}
          >
            <Button type="primary" size='small'>Edit</Button>
          </div>
        );
      },
    },
  ];
  return (
    <div>
      <Table dataSource={our_team_list} columns={columns} />
    </div>
  )
}

export default OurTeamTable